export const firstLetterUpperCase = (str) => str
    .split('')
    .map((letter, index) => (index ? letter.toLocaleLowerCase() : letter.toLocaleUpperCase()))
    .join('');
